import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTestFlight } from "@/context/TestFlightContext";
import { ArrowRight } from "lucide-react";

const HIDDEN_PATHS = [
  "/admin",
  "/venue",       // portal exact
  "/waitlist-thanks",
];

function shouldHide(pathname) {
  if (pathname.startsWith("/admin")) return true;
  if (pathname === "/venue" || pathname.startsWith("/venue/")) return true;
  return HIDDEN_PATHS.some((p) => pathname === p);
}

export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const { openTestFlight } = useTestFlight();
  // Hide while the hero (with its own "Get the app" button) is on screen —
  // avoids two identical CTAs in the first viewport. Pages without a hero
  // keep the always-visible behaviour.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (shouldHide(pathname)) return;
    const hero = document.querySelector('[data-testid="hero-section"]');
    if (!hero) {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0.15 }
    );
    io.observe(hero);
    return () => io.disconnect();
  }, [pathname]);

  if (shouldHide(pathname)) return null;
  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-40 md:hidden pointer-events-none transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      data-testid="sticky-mobile-cta"
    >
      <div className="p-3 pb-[calc(env(safe-area-inset-bottom,0)+12px)] bg-gradient-to-t from-black/85 via-black/70 to-transparent backdrop-blur-md pointer-events-auto">
        <button
          onClick={openTestFlight}
          data-testid="sticky-mobile-cta-button"
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-neon-cyan to-neon-violet text-black font-semibold py-3.5 shadow-lg shadow-neon-cyan/20 active:scale-[0.98] transition-transform"
        >
          Download free <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
